import { NgModule } from '@angular/core';
import { SharedLibraryComponent } from './shared-library.component';



@NgModule({
  declarations: [
    SharedLibraryComponent
  ],
  imports: [
  ],
  exports: [
    SharedLibraryComponent
  ]
})
export class SharedLibraryModule { }
